import React, { useCallback, useMemo, useState } from "react";
import ProductCard from "../WidgetCard/ProductCard";
import useCachedViewTrack, {
	TRACKED_TARGET,
} from "../../hooks/useCachedViewTrack";
import brandEventPropertyMapper from "../../utils/brandEventPropertyMapper";
import { eventTypes } from "../../hooks/useTrack";
import useExperience from "../../hooks/useExperience";
import { SNOWPLOW_EVENT } from "../../utils/snowplowEventMigrator";
import brandOfferEntityMapper from "../../utils/brandOfferEntityMapper";
import { SNOWPLOW_SCHEMA_DATA_KEY } from "../../utils/snowplowEventMigrator";
import { BRAND_CLICK_TARGET } from "../../event_conf";
import { WIDGET_TYPE, WIDGET_VERSION } from "../../conf";
import OfferRowCard from "../EssentialWidget/OfferRowCard";

const LeadGenBottomRowElement = ({
	brand,
	product,
	idx,
	parentContainerRef,
	isParentInView,
}) => {
	const { activeWidgetType, activeWidgetVersion } = useExperience();
	const { id: brandId } = brand;

	const brandDefaultEventProps = useMemo(
		() => ({
			...brandEventPropertyMapper({
				brand,
				order: idx,
			}),
			initiatingTarget: BRAND_CLICK_TARGET.BOTTOM_SLOT,
			...(activeWidgetType === WIDGET_TYPE.ESSENTIAL &&
				activeWidgetVersion ===
					WIDGET_VERSION[WIDGET_TYPE.ESSENTIAL][0.2] && {
					[SNOWPLOW_SCHEMA_DATA_KEY]: {
						...brandOfferEntityMapper({
							brand,
						}),
					},
				}),
		}),
		[activeWidgetType, activeWidgetVersion, brand, idx]
	);

	const [canTrack, setCanTrack] = useState(false);
	const [canTrackThreshold, setCanTrackThreshold] = useState(false);

	const onProductDisplayTrack = useCallback(() => setCanTrack(true), []);

	const onProductThresholdDisplayTrack = useCallback(
		() => setCanTrackThreshold(true),
		[]
	);

	const viewTrackBrandId = useMemo(() => `${brandId}_bottom_slot`, [brandId]);

	useCachedViewTrack({
		id: viewTrackBrandId,
		key: TRACKED_TARGET.BRAND,
		event: eventTypes.WIDGET_BRAND_DISPLAY,
		properties: brandDefaultEventProps,
		canTrack,
	});

	useCachedViewTrack({
		id: viewTrackBrandId,
		key: TRACKED_TARGET.VIEWABLE_THRESHOLD_BRAND,
		event: SNOWPLOW_EVENT.WIDGET_VIEWABLE_THRESHOLD_BRAND_DISPLAY,
		properties: brandDefaultEventProps,
		canTrack: canTrackThreshold,
	});

	const sharedProps = {
		key: idx,
		idx,
		product,
		parentBrand: brand,
		isParentBrandInView: isParentInView,
		parentBrandRef: parentContainerRef.current,
		onDisplayTrack: onProductDisplayTrack,
		onThresholdDisplayTrack: onProductThresholdDisplayTrack,
	};

	if (activeWidgetType === WIDGET_TYPE.ESSENTIAL) {
		return <OfferRowCard {...sharedProps} />;
	}

	return <ProductCard {...sharedProps} parentBrandIdx={0} disableAnimation />;
};
export default LeadGenBottomRowElement;
